export default class Auth {
  static getAuthorization () {
    return localStorage.getObject('user.authorization', false)
  }

  static isAdmin () {
    return localStorage.getObject('user.admin', false)
  }

  static getAccessToken () {
    let authorization = this.getAuthorization()

    return authorization ? 'Bearer ' + authorization.accessToken : false
  }

  static getRefreshToken () {
    let authorization = this.getAuthorization()

    return authorization ? authorization.refreshToken : false
  }

  static setAuthorization (user) {
    localStorage.setObject('user.name', user.user)
    localStorage.setObject('user.authorization', user.accessKey)
    localStorage.setObject('user.admin', user.admin)
  }

  static deleteAuthorization () {
    localStorage.deleteObject('user.name')
    localStorage.deleteObject('user.authorization')
    localStorage.deleteObject('user.admin')
  }
}



// WEBPACK FOOTER //
// ./src/models/auth.js